<template>
    <v-card class="pa-3 ma-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista Ventas</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right v-if="user.role != 11">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="
                        form_dialog = true;
                        venta = {};
                    "
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nueva Venta</span>
        </v-tooltip>

        <v-row>
            <v-col cols="12">
                <FilterComponentVue
                    :headers="filter_headers"
                    :onlySearch="user.role == 11 || user.role == 14"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>
        </v-row>
        <v-data-table
            :server-items-length="totalItems"
            dense
            :headers="headers"
            fixed-header
            height="80vh"
            :items="ventas"
            :search="filtros_prueba.search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :item-class="row_classes"
            @click:row="
                (item) => {
                    if (user.role != 11 && user.role != 6) {
                        venta = item;
                        form_dialog = true;
                    }
                }
            "
            @update:options="loadItems"
        >
            <template v-slot:item.pagado="{ item }">
                <div
                    @click.stop="openModalPagada(item)"
                    :style="`background-color:${
                        item.pagado == 1
                            ? 'green'
                            : item.pagado == 0
                            ? 'red'
                            : 'orange'
                    }`"
                    class="circle"
                ></div>
            </template>
            <template v-slot:item.importe_iva="{ item }">
                {{ formatPrice(item.importe_iva) }}€
            </template>
            <template v-slot:item.importe="{ item }">
                {{ formatPrice(item.importe) }}€
            </template>
            <template v-slot:item.cobro_1="{ item }">
                <template v-if="item.cobro_1">
                    {{ formatPrice(item.cobro_1) }}€
                </template>
            </template>
            <template v-slot:item.cobro_2="{ item }">
                <template v-if="item.cobro_2">
                    {{ formatPrice(item.cobro_2) }}€
                </template>
            </template>
            <template v-slot:item.fecha_firma="{ item }">
                {{ item.fecha_firma | format_date }}
            </template>
            <template v-slot:item.fecha_reunion="{ item }">
                {{ item.fecha_reunion | format_date }}
            </template>
            <template v-slot:item.fecha_iva="{ item }">
                <template v-if="item.fecha_iva">
                    {{ item.fecha_iva | format_date }}
                </template>
            </template>
            <template v-slot:item.fecha_factura="{ item }">
                <template v-if="item.fecha_factura">
                    {{ item.fecha_factura | format_date }}
                </template>
            </template>
            <template v-slot:item.justificacion_1="{ item }">
                <div
                    style="
                        background-color: rgba(0, 128, 0, 0.144);
                        text-align: center;
                        padding: 1rem;
                    "
                    v-if="item.justificacion_1 != null"
                >
                    {{ item.justificacion_1 | format_date }}
                </div>
            </template>
            <template v-slot:item.justificacion_2="{ item }">
                <div
                    style="
                        background-color: rgba(0, 128, 0, 0.144);
                        text-align: center;
                        padding: 1rem;
                    "
                    v-if="item.justificacion_2 != null"
                >
                    {{ item.justificacion_2 | format_date }}
                </div>
            </template>
            <template v-slot:item.observaciones="{ item }">
                {{ item.observaciones ?? "Sin observaciones" }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click.stop="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>

        <v-card v-if="user.role != 6">
            <v-card-text class="mt-3">
                <v-row>
                    <v-col
                        class="text-center"
                        style="border-right: 1px solid #1d2735"
                    >
                        <h4>Total Importe:</h4>
                        <span>{{ formatPrice(importe_total) }}€</span>
                    </v-col>
                    <v-col
                        class="text-center"
                        style="border-right: 1px solid #1d2735"
                    >
                        <h4>Total Importe IVA:</h4>
                        <span>{{ formatPrice(importe_iva) }}€</span>
                    </v-col>
                    <v-col
                        class="text-center"
                        style="border-right: 1px solid #1d2735"
                    >
                        <h4>Total Cobro IVA:</h4>
                        <span>{{ formatPrice(importe_iva_cobrado) }}€</span>
                    </v-col>

                    <v-col
                        class="text-center"
                        style="border-right: 1px solid #1d2735"
                    >
                        <h4>Total Cobro 1:</h4>
                        <span>{{ formatPrice(total_cobro_1) }}€</span>
                    </v-col>

                    <v-col
                        class="text-center"
                        style="border-right: 1px solid #1d2735"
                    >
                        <h4>Total Cobro 2:</h4>
                        <span>{{ formatPrice(total_cobro_2) }}€</span>
                    </v-col>

                    <v-col
                        class="text-center"
                        style="border-right: 1px solid #1d2735"
                    >
                        <h4>Total Cobrado:</h4>
                        <span
                            >{{
                                formatPrice(
                                    total_cobro_1 +
                                        total_cobro_2 +
                                        importe_iva_cobrado
                                )
                            }}€</span
                        >
                    </v-col>

                    <v-col class="text-center">
                        <h4>Total:</h4>
                        <span
                            >{{
                                formatPrice(importe_total + importe_iva)
                            }}€</span
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <Resumen v-if="user.role == 1 || user.role == 5"></Resumen>
        <v-dialog v-model="form_dialog" max-width="800px"
            ><FormVentas
                @getCategorias="getCategorias"
                :categorias="categorias"
                :usuarios="usuarios"
                :empleados="empleados"
                @close_modal="
                    () => {
                        form_dialog = false;
                        getVentas();
                    }
                "
                v-model="venta"
            ></FormVentas
        ></v-dialog>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_pagada" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>
                        ¿Estás seguro que deseas marcar la venta como
                        {{ selectedItem.pagada ? "no" : "" }} pagada?
                    </h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_pagada = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="pagada()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<style>
.circle {
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    display: inline-block;
}

/* Fijar primera columna */
.v-data-table__wrapper > table > thead > tr > th:first-child,
.v-data-table__wrapper > table > tbody > tr > td:first-child {
    position: sticky !important;
    left: 0;
    z-index: 2;
}

/* Header con fondo blanco y sombra */
.v-data-table__wrapper > table > thead > tr > th:first-child {
    background-color: white !important;
    z-index: 3;
    box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Estilos para la primera columna según el estado de la fila */
.pointer td:first-child {
    background-color: white !important;
}

.pointer:hover td:first-child {
    background-color: inherit !important;
}

.red-row td:first-child {
    background-color: inherit !important;
}

.red-row:hover td:first-child {
    background-color: inherit !important;
}

/* Resto de las columnas */
.v-data-table__wrapper > table > thead > tr > th:not(:first-child),
.v-data-table__wrapper > table > tbody > tr > td:not(:first-child) {
    z-index: 1;
}
</style>
<script>
import debounce from "lodash/debounce";
import FormVentas from "./FormVentas.vue";
import FilterComponentVue from "../../../../components/general/FilterComponent.vue";
import Resumen from "./ListaResumenVentas.vue";
import { sortBy } from "lodash";
import { formatPrice, parseEuroNumber } from "../../../../utils/formatters";
import { mapGetters } from "vuex";

export default {
    components: { FormVentas, FilterComponentVue, Resumen },
    data() {
        return {
            dialog_pagada: false,
            totalItems: 0,
            search: "",
            filtros_prueba: {
                search: "",
                empresa: {},
                dia: {},
            },
            filter_headers: [
                {
                    title: "Categoria",
                    type: "select",
                    active: false,
                    model: "categoria",
                    item_text: "nombre",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Cliente",
                    type: "select",
                    active: false,
                    model: "cliente",
                    item_text: "nombres",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Responsable",
                    type: "select",
                    active: false,
                    model: "responsable",
                    item_text: "nombres",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Vendedor",
                    type: "select",
                    active: false,
                    model: "vendedor",
                    item_text: "nombres",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Fecha Firma",
                    type: "date",
                    active: true,
                    model: "dia",
                },
                {
                    title: "Fecha Facturado",
                    type: "date",
                    active: true,
                    model: "fecha_factura",
                },
                {
                    title: "Justificación 1",
                    type: "date_range",
                    active: true,
                    model: "justificacion_1",
                },
                {
                    title: "Justificación 2",
                    type: "date_range",
                    active: true,
                    model: "justificacion_2",
                },
            ],
            headers_admin: [
                { text: "Núm Acuerdo", value: "num_acuerdo", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                {
                    text: "Razón Social",
                    value: "cliente.nombre_fiscal",
                    sortable: false,
                },
                {
                    text: "Categoría",
                    value: "categoria.nombre",
                    sortable: false,
                },

                { text: "Action", value: "action", sortable: false },
            ],

            ///'num_acuerdo','importe','id_cliente','id_categoria','fecha_firma','fecha_iva','justificacion_1','cobro_1','justificacion_2','cobro_2'
            form_dialog: false,
            venta: {},
            ventas: [],
            selectedItem: 0,
            dialog: false,
            categorias: [],
            usuarios: [],
            empleados: [],
            page: 1,
            itemsPerPage: 15,
            sortBy: null,
            sortDesc: false,
            importe_iva: 0,
            importe_iva_cobrado: 0,
            importe_total: 0,
            total_cobro_1: 0,
            total_cobro_2: 0,
        };
    },
    created() {
        this.getVentas();
        this.getCategorias();
        this.getUsuarios();
        this.getEmpleados();
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (n) {
                this.getVentas();
            }, 500),
        },
    },
    methods: {
        pagada() {
            axios.get(`api/pagar-ventas-kit/${this.selectedItem.id}`).then(
                (res) => {
                    this.getVentas();
                    this.dialog_pagada = false;
                },
                (err) => {
                    this.$toast.error("Error consultando clientes");
                }
            );
        },
        loadItems(newOptions) {
            // console.log(newOptions);
            this.page = newOptions.page;
            this.itemsPerPage = newOptions.itemsPerPage;
            this.sortBy = newOptions.sortBy[0];
            this.sortDesc = newOptions.sortDesc[0];
            this.getVentas();
        },
        getEmpleados() {
            axios.post(`api/get-usuarios-empleados-all`).then(
                (res) => {
                    this.empleados = res.data.users;
                    this.filter_headers[2].items = res.data.users;
                    this.filter_headers[3].items = res.data.users;
                },
                (err) => {
                    this.$toast.error("Error consultando empleados");
                }
            );
        },
        getUsuarios() {
            axios.get(`api/get-usuarios`).then(
                (res) => {
                    this.usuarios = res.data.users;
                    this.filter_headers[1].items = res.data.users;
                },
                (err) => {
                    this.$toast.error("Error consultando clientes");
                }
            );
        },
        getCategorias() {
            const self = this;

            axios
                .get(`api/get-categorias-kit-digital`)
                .then(function (response) {
                    self.categorias = response.data;
                    self.filter_headers[0].items = response.data;
                });
        },
        generateYears() {
            const currentYear = new Date().getFullYear();
            const startYear = 2022;
            const years = [];

            for (let year = startYear; year <= currentYear; year++) {
                years.push(year);
            }
        },
        getVentas() {
            const filtros_prueba = this.filtros_prueba;
            const self = this;

            axios
                /*.get(
                    `api/get-ventas-kit?amount=${this.itemsPerPage}&page=${this.page}${search_str}`
                )*/
                .get(`api/get-ventas-kit`, {
                    params: {
                        amount: this.itemsPerPage,
                        page: this.page,
                        sort_by: this.sortBy ?? null,
                        sort_desc: this.sortDesc ?? null,
                        search: filtros_prueba.search,
                        id_categoria: filtros_prueba.categoria?.value ?? null,
                        id_cliente: filtros_prueba.cliente?.value ?? null,
                        id_responsable:
                            filtros_prueba.responsable?.value ?? null,
                        id_vendedor: filtros_prueba.vendedor?.value ?? null,
                        fecha_inicio: filtros_prueba.dia?.start ?? null,
                        fecha_fin: filtros_prueba.dia?.end ?? null,
                        fecha_factura_inicio:
                            filtros_prueba.fecha_factura?.start ?? null,
                        fecha_factura_fin:
                            filtros_prueba.fecha_factura?.end ?? null,
                        justificacion_1_inicio:
                            filtros_prueba.justificacion_1?.start ?? null,
                        justificacion_1_fin:
                            filtros_prueba.justificacion_1?.end ?? null,
                        justificacion_2_inicio:
                            filtros_prueba.justificacion_2?.start,
                        justificacion_2_fin:
                            filtros_prueba.justificacion_2?.end ?? null,
                    },
                })
                .then(
                    (res) => {
                        self.ventas = res.data.data;
                        self.totalItems = res.data.total;
                        self.importe_iva = res.data.importe_iva;
                        self.importe_iva_cobrado = res.data.importe_iva_cobrado;
                        self.importe_total = res.data.importe_total;
                        self.total_cobro_1 = res.data.total_cobro_1;
                        self.total_cobro_2 = res.data.total_cobro_2;
                    },
                    (err) => {
                        this.$toast.error("Error consultando Ventas");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = item;
            this.dialog = true;
        },
        openModalPagada(item) {
            this.selectedItem = item;
            this.dialog_pagada = true;
        },
        deleteUser() {
            axios
                .post("api/delete-venta-kit", {
                    id: this.selectedItem.id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Venta eliminado");
                        this.dialog = false;
                        this.getVentas();
                    },
                    (err) => {
                        this.$toast.error("Error eliminando Venta");
                    }
                );
        },
        formatPrice,
        row_classes(item) {
            if (this.user.role != 11) {
                if (item.desestimar) {
                    return "red-row pointer";
                } else {
                    return "pointer";
                }
            } else {
                return "pointer";
            }
        },
    },
    computed: {
        ...mapGetters({
            userRole: "auth/userRole",
            userData: "auth/userData",
            userDataTemp: "auth/userDataTemp",
        }),
        user() {
            // return this.userData;
            return this.userDataTemp;
        },
        headers() {
            let headers = [
                {
                    text: "Razón Social",
                    value: "cliente.nombres",
                    sortable: false,
                },
                /*{ text: "Núm Acuerdo", value: "num_acuerdo", sortable: false },
                {
                    text: "Bono Digital",
                    value: "bono_digital",
                    sortable: false,
                },*/
                {
                    text: "Vendedor",
                    value: "vendedor.nombre",
                    sortable: false,
                },
                { text: "Importe", value: "importe", sortable: false },
                /*{
                    text: "Responsable",
                    value: "responsable.nombre",
                    sortable: false,
                },*/

                {
                    text: "IVA",
                    value: "importe_iva",
                    sortable: false,
                },
                {
                    text: "Categoría",
                    value: "categoria.nombre",
                    sortable: false,
                },
                {
                    text: "Fecha Firma",
                    value: "fecha_firma",
                    sortable: true,
                },
                /*{
                    text: "estado del proyecto",
                    value: "estado_proyecto",
                    sortable: false,
                },*/
                {
                    text: "Observaciones",
                    value: "observaciones",
                    sortable: false,
                },
                {
                    text: "Fecha Reunión",
                    value: "fecha_reunion",
                    sortable: true,
                },

                {
                    text: "Fecha facturado",
                    value: "fecha_factura",
                    sortable: true,
                },
                {
                    text: "Fecha IVA Pagado",
                    value: "fecha_iva",
                    sortable: true,
                },
                {
                    text: "Justificación 1",
                    value: "justificacion_1",
                    sortable: true,
                },
                {
                    text: "Cobro 1",
                    value: "cobro_1",
                    sortable: false,
                },
                {
                    text: "Justificación 2",
                    value: "justificacion_2",
                    sortable: true,
                },
                {
                    text: "Cobro 2",
                    value: "cobro_2",
                    sortable: false,
                },
                {
                    text: "Pagado",
                    value: "pagado",
                    sortable: false,
                },

                ...(this.user?.role != 11
                    ? [{ text: "Acciones", value: "action", sortable: false }]
                    : []),
            ];

            if (this.user?.role == 6) {
                headers = headers.filter((header) => {
                    if (header.value == "importe") {
                        return false;
                    } else if (header.value == "importe_iva") {
                        return false;
                    } else if (header.value == "cobro_1") {
                        return false;
                    } else if (header.value == "cobro_2") {
                        return false;
                    } else if (header.value == "pagado") {
                        return false;
                    } else if (header.value == "action") {
                        return false;
                    }
                    return true;
                });
            }

            return headers;
        },
        isLoading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
